import { Routes } from '@angular/router';
import { AuthGuardService } from './authentication/guards/auth-guard.service';
import { FullComponent } from './layouts/full/full.component';
import { BlueButtonComponent } from './authentication/blue-button/blue-button.component';
import { UnauthorizedComponent } from './authentication/unauthorized/unauthorized.component';

export const AppRoutes: Routes = [
  {
    path: '', 
    loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
  }, 
  {
    path: 'callback',
    component: BlueButtonComponent
  },
  {
    path: 'app',
    component: FullComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'careplan',
        loadChildren: () => import('./careplan/careplan.module').then(m => m.CareplanModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule)
      },
      {
        path: 'care-rewards',
        loadChildren: () => import('./my-care-rewards/my-care-rewards.module').then(m => m.MyCareRewardsModule)
      },
      {
        path: 'tier-benefits',
        loadChildren: () => import('./my-tier-benefits/my-tier-benefits.module').then(m => m.MyTierBenefitsModule)
      },
      {
        path: 'clinical-information',
        loadChildren: () => import('./my-clinical-data/my-clinical-data.module').then(m => m.MyClinicalDataModule)
      },
      {
        path: 'my-inbox',
        loadChildren: () => import('./my-inbox/my-inbox.module').then(m => m.MyInboxModule)
      }, 
      {
        path: 'my-profile',
        loadChildren: () => import('./my-profile/my-profile.module').then(m => m.MyProfileModule)
      },
      {
        path: 'book-appointment',
        loadChildren: () => import('./appointment/appointment.module').then(m => m.AppointmentModule)
      },
      {
        path: 'message',
        loadChildren: () => import('./message/message.module').then(m => m.MessageModule)
      },
      {
        path: 'unauthorize',
        component: UnauthorizedComponent
      },
      {
        path: 'home',
        component: UnauthorizedComponent
      }
    ]
  },
  {
    path: 'appointment',
    loadChildren: () => import('./appointment/appointment.module').then(m => m.AppointmentModule)
  },
  {
    path: '**',
    redirectTo: 'authentication/404'
  }
];
